import { render, staticRenderFns } from "./CustomerHubInvoices.vue?vue&type=template&id=4fd80181&scoped=true"
import script from "./CustomerHubInvoices.vue?vue&type=script&lang=js"
export * from "./CustomerHubInvoices.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubInvoices.vue?vue&type=style&index=0&id=4fd80181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd80181",
  null
  
)

export default component.exports